export default "__VITE_ASSET__74a17d10__"